import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { TenantCompany, TenantCompanyResponse } from '../../../models/tenant-company/tenant-company.model';

@Injectable({
  providedIn: 'root',
})
export class ApiTenantCompanyService {
  private baseUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private apiMethodService: ApiMethodService
  ) { }

  getTenantCompanies(): Observable<TenantCompanyResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<TenantCompanyResponse>(
      '/backoffice/GetTenantCompanies', // Hypothetical endpoint
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'GetTenantCompanies',
        token: token,
        headerOnly: false,
      }
    );
  }
}
